import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

import logo from "../assets/aerw-logo.png";

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Meet Your Companions', path: '/companions' },
];

const supportLinks = [
  { name: 'Pricing', path: '/pricing' },
  { name: 'Contact Us', path: '/contact#consultation-form' },
  { name: 'FAQ', path: '/contact#faq' },
];

const legalLinks = [
  { name: 'Terms & Conditions', path: '/policies#terms' },
  { name: 'Privacy Policy', path: '/policies#privacy' },
  { name: 'Complaints Policy', path: '/policies#complaints' },
  { name: 'Policies', path: '/policies' },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1E4F8A] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <img src={logo} alt="AERW Lifestyle" />
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Premium non-regulated companionship and lifestyle support services across the United Kingdom. 
              Supporting wellbeing, independence, and connection.
            </p>
            <div className="space-y-3">
              <a 
                href="mailto:admin@aerwlifestyle.co.uk"
                className="flex items-center text-sm text-white/80 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 mr-3 flex-shrink-0" />
                admin@aerwlifestyle.co.uk
              </a>
              <a 
                href="tel:07803174495"
                className="flex items-center text-sm text-white/80 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4 mr-3 flex-shrink-0" />
                07803 174495
              </a>
              <div className="flex items-start text-sm text-white/80">
                <MapPin className="w-4 h-4 mr-3 flex-shrink-0 mt-0.5" />
                <span>71-75 Shelton Street, Covent Garden, London, WC2H 9JQ</span>
              </div>
            </div>

            
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                    data-testid={`footer-link-${link.path.replace('/', '') || 'home'}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Support</h4>
            <ul className="space-y-3">
              {supportLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

                   {/* Legal */}
          <div>
             <h4 className="font-semibold text-lg mb-6">Legal</h4>
               <ul className="space-y-3">
                  {legalLinks.map((link) => (
                    <li key={link.path}>
                       <Link
                         to={link.path}
                           className="text-sm text-white/80 hover:text-white transition-colors"
                       >
                         {link.name}
                        </Link>
                     </li>
                   ))}
                </ul>
            </div>

        </div>       

                 {/* Bottom Bar */}
        <div className="py-6 border-t border-white/20">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/70">
              © {currentYear} AERW Lifestyle. All rights reserved.
            </p>
            <p className="text-sm text-white/70">
              Premium Lifestyle Companionship | United Kingdom
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
